import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=7c077ba8&scoped=true&"
var script = {}
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=7c077ba8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c077ba8",
  null
  
)

export default component.exports